/**
 * @generated SignedSource<<fbd27956a2625059a2224c95bd146bd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedAppSetupModalFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "FeedAppSetupModalFragment";
};
export type FeedAppSetupModalFragment$key = {
  readonly " $data"?: FeedAppSetupModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedAppSetupModalFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedAppSetupModalFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};

(node as any).hash = "1666a62e87f6e13794784fa813ba5111";

export default node;
